import template from './activity-feed.component.html';
import controller from './activity-feed.controller';

const activityFeed = {
  template,
  controller,
};

export default activityFeed;
